import { useState } from 'react'

import { Box, Flex, FloraButton, FloraInput } from '@grupoboticario/flora-react'

interface SearchInputProps {
  placeholder?: string
  buttonLabel?: string
  onSubmit?: (value: string) => void
  loading?: boolean
  type?: string
  leftIcon?: React.ReactElement
  formatValue?: (value: string) => string
  id?: string
}

const SearchInput = ({
  placeholder = '',
  buttonLabel = 'Buscar',
  onSubmit = () => {},
  loading = false,
  type = 'text',
  leftIcon,
  formatValue = (v) => v,
  id
}: SearchInputProps) => {
  const [value, setValue] = useState('')
  const inputId = id ?? 'search-input'

  const handleSubmit = () => {
    if (loading) return
    onSubmit(value)
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (loading) return
    if (e.key === 'Enter') handleSubmit()
  }

  return (
    <Flex gap="$3" css={{ marginBottom: '$4' }}>
      <Box css={{ flex: 1, position: 'relative' }}>
        <FloraInput
          id={inputId}
          label={placeholder}
          leftIcon={leftIcon}
          onChange={(e) => setValue(formatValue(e.target.value))}
          onKeyDown={handleKeyDown}
          type={type}
          value={value}
          size="medium"
        />
      </Box>
      <FloraButton disabled={loading} isLoading={loading} onClick={handleSubmit}>
        {buttonLabel}
      </FloraButton>
    </Flex>
  )
}

export { SearchInput }
